module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAUCAYAAACeXl35AAAAAXNSR0IArs4c6QAAAVJJREFUSEu91DFuwjAUBuD/gRSxZKEXaG+A7CwRC2MreorSe5Teo3AKqjIytGKxLY7ACViyVJHgVY7SCqhJbKtq1tjvi5P8P+GfL4rxsix7sPuUUvPQ/cGglFIAeAdg9w611iYEDQLzPO+XZakA3NTINkkSuV6vd75oCNgRQiyI6O54ODO/GWPuARx8UG9QCPFERFPXUGaeGmOe/wwUQtwS0SuAzoWhB2YeG2OWbWjrCQeDwXW327Xf7apl2G6/38vNZrNtWtcIjkajXlEU9o+UbU9e3zdpmg5Xq9XnpfWNoJTyBcDEE/teNtNaPwaDNtzMPAvEquVENLlUCs4T1uH+ANCLAQHYV+oshV+gI9yRJpylcA46wx0rEtFSKTU+LoUTsCncseh5KfyAHuGONU9KoQLrcGsA/dipvqVAEeGOfaaqFCgy3FEoM89buzRqcsOmL0JshRDORHJRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/details/triangle.png
// module id = kfOa
// module chunks = 0